<ntap-prime-common-itemview [class]="obrazacClass" #itemView></ntap-prime-common-itemview>
<app-objekti-pojavnog-oblika [activeTab]="itemView.activeTab"></app-objekti-pojavnog-oblika>